import React from "react";
import type { IListingHost } from "@/src/shared/types/listing";
import { listingService } from "../services";

/** The app's "Hosted by" row: avatar, name, "Identity verified · N years hosting". */
const HostedByRow: React.FC<{ host: IListingHost }> = ({ host }) => {
  const firstName = host.first_name?.trim() || host.last_name?.trim() || "";
  if (!firstName) return null;

  return (
    <div className="flex items-center gap-4">
      {host.image?.url ? (
        <img
          src={host.image.url}
          alt=""
          className="h-14 w-14 shrink-0 rounded-full object-cover"
        />
      ) : (
        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[#D6D6D6] text-22 font-semibold text-ink-dark">
          {firstName.charAt(0).toUpperCase()}
        </span>
      )}
      <div className="min-w-0">
        <p className="truncate text-base font-medium text-ink">
          Hosted by {firstName}
        </p>
        <p className="mt-0.5 flex items-center gap-2 text-sm font-medium text-ink-secondary">
          <img
            src="/icons/listing/listing_identity_verified.svg"
            alt=""
            className="h-5 w-5"
          />
          {listingService.hostedByLine(host.years_hosting)}
        </p>
      </div>
    </div>
  );
};

export default HostedByRow;
